import React, { useState } from "react";
import {
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useHttp from "../../../Hooks/use-http";
import { toast } from "react-toastify";

const AddNewDocumentMaster = ({ isRefresh, onClose }) => {
  const [documentForm, setDocumentForm] = useState({
    country: "India",
    documentName: "",
    documentNote: "",
    category: "Driver",
    hasExpiry: false,
    required: true,
    // verifyID: true,
    verificationRequired: false,
    type: "All",
    isDisabled: false,
    canUpload: false,
  });

  const { isLoading, sendRequest } = useHttp();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setDocumentForm({
      ...documentForm,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await sendRequest({
        url: "/addupdatedocumentmaster",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: documentForm,
        }
      });
  
      if (response.status === 200 || response.status === 201) {
        // onSubmit(documentForm);
        toast.success(response.message)
        isRefresh(true)
        onClose();
      } else {
        console.error("Failed to create or update document. Status:", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  return (
    <>
      <Box component="form" noValidate autoComplete="off" sx={{ p: 0 }}>
        {/* Header with Blue Background and Cross Button */}
        <Box
          sx={{
            backgroundColor: "rgba(34, 137, 203, 255)",
            color: "white",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "-24px",
            flexDirection: "row",
            marginBottom: "2%",
          }}
        >
          <Typography variant="h6" component="div">
            ADD DOCUMENT
          </Typography>
        </Box>

        {/* Form Fields */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Country"
              name="country"
              variant="standard"
              value={documentForm.country}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                label="Category"
                name="category"
                value={documentForm.category}
                variant="standard"
                onChange={handleInputChange}
              >
                <MenuItem value="Driver">Driver</MenuItem>
                <MenuItem value="Partner">Partner</MenuItem>
                <MenuItem value="Vehicle">Vehicle</MenuItem>
                <MenuItem value="Corporate">Corporate</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Document Name"
              name="documentName"
              variant="standard"
              value={documentForm.documentName}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Document Note"
              name="documentNote"
              variant="standard"
              value={documentForm.documentNote}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="canUpload"
                  checked={documentForm.canUpload}
                  onChange={handleInputChange}
                />
              }
              label="Can Upload"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select
                label="Type"
                name="type"
                variant="standard"
                value={documentForm.type}
                onChange={handleInputChange}
              >
                <MenuItem value="jpg">JPG</MenuItem>

              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="hasExpiry"
                  checked={documentForm.hasExpiry}
                  onChange={handleInputChange}
                />
              }
              label="Has Expiry"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="required"
                  checked={documentForm.required}
                  onChange={handleInputChange}
                />
              }
              label="Required"
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="verifyID"
                  checked={documentForm.verifyID}
                  onChange={handleInputChange}
                />
              }
              label="Verify ID"
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="verificationRequired"
                  checked={documentForm.verificationRequired}
                  onChange={handleInputChange}
                />
              }
              label="Verification Required"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="isDisabled"
                  checked={documentForm.isDisabled}
                  onChange={handleInputChange}
                />
              }
              label="Is Disabled"
            />
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: "#44B150",
              color: "white",
              ":hover": {
                backgroundColor: "#44B150",
                opacity: 0.8,
              },
              width: "auto",
            }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default AddNewDocumentMaster;
